const cidades = (state) => ({ codigo_uf }) => {
  return state.cidades[codigo_uf] || []
}

const estados = (state) => {
  return state.estados || []
}

export { cidades, estados }
